import 'css-chunk-1JavaScriptSource/components/context-menu/style.module.scss';export default {
  "contextMenu": "_contextMenu_11qgd_1",
  "separator": "_separator_11qgd_21",
  "shortcut": "_shortcut_11qgd_50"
};